<template>
<div>
    <van-nav-bar :left-arrow="true" left-text="返回" title="自定义模式" fixed :placeholder="true" @click-left="goBack">
        <van-icon v-if="this.configId" name="delete" slot="right" @click="deleteRule" />
    </van-nav-bar>
    <div>
        <van-cell title="规则名称" style="display: flex;align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">规则名称</span>
                <span style="color: red; margin-left: 2px;">*</span>
            </template>
            <van-field v-model="ruleInfo.name" placeholder="请输入规则名称" rows="1" right clearable style="display: flex;justify-content: right;text-align: right;" />
        </van-cell>
        <!-- 院线选择 - 支持多选和包含/排除 -->
        <van-cell is-link :value="ruleInfo.gp_line_desc || '不限'" @click="showGplineSelect(false)" :class="getGplineColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">院线</span>
            </template>
        </van-cell>
        <!-- 省份选择 - 统一使用scope_type和scope字段 -->
        <van-cell is-link :value="ruleInfo.province_desc || '不限'" @click="showProvinceSelect()" :class="getProvinceColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">省份</span>
            </template>
        </van-cell>
        <!-- 城市选择 - 统一使用scope_type和scope字段 -->
        <van-cell is-link :value="ruleInfo.city_desc || '不限'" @click="showCitySelect()" :class="getCityColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">城市</span>
            </template>
        </van-cell>
    </div>
    <div style="margin-top: 20px;">
        <!-- 影院选择 - 统一使用scope_type和scope字段 -->
        <van-cell is-link :value="ruleInfo.cinema_desc || '不限'" @click="showCinemaSelect()" :class="getCinemaColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">影院</span>
            </template>
        </van-cell>
        <!-- 影院分类 -->
        <van-cell is-link :value="ruleInfo.class_desc || '不限'" @click="showClassSelect()" :class="getClassColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">影院分类</span>
            </template>
        </van-cell>
        <!-- 影厅选择 - 统一使用scope_type和scope字段 -->
        <van-cell is-link :value="ruleInfo.hall_desc || '不限'" @click="showHallSelect()" :class="getHallColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">影厅</span>
            </template>
        </van-cell>
        <!-- 电影选择 - 统一使用scope_type和scope字段 -->
        <van-cell is-link :value="ruleInfo.movie_desc || '不限'" @click="showMovieSelect()" :class="getMovieColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">电影</span>
            </template>
        </van-cell>
    </div>

    <van-cell-group style="margin-top: 20px;">
        <van-cell class="custom-cell" style="display: flex;align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">市场价</span>
            </template>
            <van-row style="display: flex;align-items: center;">
                <van-field v-model="ruleInfo.begin_price" placeholder="最低" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" />
                <hr style="width: 16px; margin: 0px 0; border: 0; border-top: 1px solid #0a0a0a;" />

                <van-field v-model="ruleInfo.end_price" placeholder="最高" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" />

            </van-row>
        </van-cell>
        <van-cell class="custom-cell" title-style="min-width:1rem;" style="display: flex; align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">放映日期</span>
            </template>
            <van-row style="display: flex;align-items: center;">

                <van-field v-model="ruleInfo.begin_date" placeholder="开始" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" @click="changeDate(1)" />
                <hr style="width: 16px; margin: 0px 0; border: 0; border-top: 1px solid #0a0a0a;" />

                <van-field v-model="ruleInfo.end_date" placeholder="结束" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" @click="changeDate(2)" />

            </van-row>

        </van-cell>
        <van-cell class="custom-cell" style="display: flex; align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">放映时间</span>
            </template>
            <van-row style="display: flex;align-items: center;">
                <van-field v-model="ruleInfo.begin_time" placeholder="开始" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" @click="changeTime(1)" />
                <hr style="width: 16px; margin: 0px 0; border: 0; border-top: 1px solid #0a0a0a;" />

                <van-field v-model="ruleInfo.end_time" placeholder="结束" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" @click="changeTime(2)" />

            </van-row>

        </van-cell>
        <van-cell is-link :value="ruleInfo.week_desc" @click="showWeekSelect">
            <template slot="title">
                <span style="font-weight: bold;">包含星期</span>
            </template>
        </van-cell>
    </van-cell-group>

    <van-cell-group style="margin-top: 20px;">
        <van-cell reverse-color class="ticket-count-cell">
            <template slot="title">
                <span style="font-weight: bold;">票数</span>
            </template>
            <van-checkbox-group v-model="ruleInfo.ticket_num" @change="handleTicketCountChange" style="display: flex; flex-wrap: wrap; justify-content: space-around;">
                <van-checkbox :name="0" style="margin: 4px;" @click.native="lastClick(0)">全部</van-checkbox>
                <van-checkbox :name="1" style="margin: 4px;" @click.native="lastClick(1)">1张</van-checkbox>
                <van-checkbox :name="2" style="margin: 4px;" @click.native="lastClick(2)">2张</van-checkbox>
                <van-checkbox :name="3" style="margin: 4px;" @click.native="lastClick(3)">3张</van-checkbox>
                <van-checkbox :name="4" style="margin: 4px;" @click.native="lastClick(4)">4张</van-checkbox>
            </van-checkbox-group>
            <!-- <div style="margin-top: 10px; font-size: 12px; color: #666;">
                已选择：{{ selectedTicketCountText }}
            </div> -->
        </van-cell>
        <van-cell reverse-color class="couple-seat-cell">
            <template slot="title">
                <span style="font-weight: bold;">情侣座</span>
            </template>
            <van-radio-group v-model="ruleInfo.seat_tag" style="display: flex; justify-content: flex-start; gap: 15px;">
                <van-radio :name="'1'" style="font-size: 13px;">包含情侣座</van-radio>
                <van-radio :name="'2'" style="font-size: 13px;">不含情侣座</van-radio>
            </van-radio-group>
        </van-cell>
        <van-cell reverse-color class="bid-mode-cell">
            <template slot="title">
                <span style="font-weight: bold;">报价模式</span>
            </template>
            <van-radio-group v-model="ruleInfo.bid_type" style="display: flex; flex-wrap: wrap; justify-content: space-between;">
                <van-radio :name="3" style="margin: 4px;">折扣报价</van-radio>
                <van-radio :name="4" style="margin: 4px;">顶价报价</van-radio>
                <van-radio :name="5" style="margin: 4px;">一口价</van-radio>
                <van-radio :name="6" style="margin: 4px;">原价立减</van-radio>
            </van-radio-group>
            <van-field v-model="ruleInfo.discount" rows="1" clearable style="width: 100%; margin-top: 15px;border: 1px solid #ebedf0; border-radius: 4px;" />
            <span style="color:red;font-size:x-small; display:flex;text-align:left;">{{ bid_type_desc[ruleInfo.bid_type] }}</span>
        </van-cell>
    </van-cell-group>

    <van-cell-group style="margin-top: 20px;">
        <van-cell style="display: flex; align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">启动状态</span>
            </template>
            <van-switch slot="right-icon" v-model="ruleInfo.status === 1" @change="setStatus" />
        </van-cell>
    </van-cell-group>

    <div style="padding: 40px 10px;">
        <van-button round type="danger" style="width: 100%;" @click="saveConfig">保存条件</van-button>
    </div>

    <!--省份弹窗-->
    <van-popup v-model="selectProvince" position="bottom">
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <span style="font-size: 16px;font-weight: bold;">选择省份</span>
            </van-row>
        </div>
        <div style="height: 320px; overflow: scroll;padding: 10px 10px 60px 10px;">
            <van-row style="flex-wrap: wrap; margin: -8px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(province, index) in filterProvinceList" :key="index" class="custom-checkbox" :class="{ 'checked': province.checked }" @click="provinceCheck(index)" style="margin: 8px;">
                    {{ province.label }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="8">
                <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个省份</span>
            </van-col>
            <van-col span="16" style="text-align: right;">
                <van-button plain size="small" type="default" @click="resetProvince">重 置</van-button>
                <van-button type="danger" size="small" style="margin-left: 20px;" @click="saveProvinceExclude">确认排除</van-button>
                <van-button type="primary" size="small" style="margin-left: 20px;" @click="saveProvince">确认选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!--城市弹窗-->
    <van-popup v-model="selectCity" position="bottom">
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <span style="font-size: 16px;font-weight: bold;">选择城市</span>
            </van-row>
        </div>
        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入城市" v-model="searchText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchText !== ''" name="clear" @click="clearCityClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchCityClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <van-tree-select :items="filterCityList" :main-active-index.sync="activeIndex" style="height: 420px;padding: 10px 10px 60px 10px;">
            <template slot="content">
                <van-row v-for="(city, index) in (filterCityList[activeIndex] && filterCityList[activeIndex].city_list ? filterCityList[activeIndex].city_list : [])" :key="index" style="background-color: white;margin-bottom: 10px;">
                    <van-cell :title="city.name" class="cell-with-margin">
                        <template #right-icon>
                            <van-checkbox v-model="city.checked" shape="square" @click="toggleCity(index)"></van-checkbox>
                        </template>
                    </van-cell>
                </van-row>

            </template>
        </van-tree-select>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="8">
                <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个城市</span>
            </van-col>
            <van-col span="16" style="text-align: right;">
                <van-button plain size="small" type="default" @click="resetCity">重 置</van-button>
                <van-button type="danger" size="small" style="margin-left: 20px;" @click="saveCityExclude">确认排除</van-button>
                <van-button type="primary" size="small" style="margin-left: 20px;" @click="saveCity">确认选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!--品牌弹窗-->
    <van-popup v-model="selectGpline" position="bottom">
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <span style="font-size: 16px;font-weight: bold;">选择院线</span>
            </van-row>
        </div>
        
        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入品牌名" v-model="searchText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchText !== ''" name="clear" @click="clearGplineClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchGplineClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <div style="height: 320px; overflow: scroll;padding: 10px 10px 60px 10px;">
            <van-row style="flex-wrap: wrap; margin: -8px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(gpline, index) in filterGplineList" :key="index" class="custom-checkbox" :class="{ 'checked': gpline.checked }" @click="gplineCheck(index)" style="margin: 8px;">
                    {{ gpline.label }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="8">
                <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个院线</span>
            </van-col>
            <van-col span="16" style="text-align: right;">
                <van-button plain size="small" type="default" @click="resetGpline">重 置</van-button>
                <van-button type="danger" size="small" style="margin-left: 20px;" @click="saveGplineExclude">确认排除</van-button>
                <van-button type="primary" size="small" style="margin-left: 20px;" @click="saveGpline">确认选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!--影院弹窗-->
    <van-popup round v-model="selectCinema" position="bottom">
        <!--弹框标题-->
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <van-col span="24" style="text-align: center;">选择影院</van-col>
            </van-row>
        </div>
        <van-dropdown-menu>
            <van-dropdown-item :title="selectCinemaFilterCityText" ref="selectCinemafilterCity">
                <van-row>
                    <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入城市" v-model="searchText" :clearable=false>
                        <template #right-icon>
                            <van-row style="display: flex;justify-content: center;align-items: center;">
                                <van-icon v-if="searchText !== ''" name="clear" @click="clearCityClick" />
                                <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchCityClick">搜索</van-button>
                            </van-row>

                        </template>
                    </van-search>
                </van-row>
                <van-tree-select :items="filterCityList" :main-active-index.sync="activeIndex" style="height: 320px;padding: 10px 10px 60px 10px;">
                    <template slot="content">
                        <van-row v-for="(city, index) in (filterCityList[activeIndex] && filterCityList[activeIndex].city_list ? filterCityList[activeIndex].city_list : [])" :key="index" style="background-color: white;margin-bottom: 10px;">
                            <van-cell :title="city.name" class="cell-with-margin">
                                <template #right-icon>
                                    <van-checkbox v-model="city.checked" shape="square" @click="toggleCity(index)"></van-checkbox>
                                </template>
                            </van-cell>
                        </van-row>

                    </template>
                </van-tree-select>
                <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
                    <van-col span="8">
                        <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个城市</span>
                    </van-col>
                    <van-col span="16" style="text-align: right;">
                        <van-button plain size="small" type="danger" @click="resetFilterCity">重 置</van-button>
                        <van-button type="danger" size="small" style="margin-left: 40px;" @click="saveFiterCity">确认选择</van-button>
                    </van-col>
                </van-row>
            </van-dropdown-item>
            <van-dropdown-item ref="selectCinemafilterGpline" :title="selectCinemaFilterGplineText">
                <van-row>
                    <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入品牌名" v-model="searchText" :clearable=false>
                        <template #right-icon>
                            <van-row style="display: flex;justify-content: center;align-items: center;">
                                <van-icon v-if="searchText !== ''" name="clear" @click="clearGplineClick" />
                                <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchGplineClick">搜索</van-button>
                            </van-row>

                        </template>
                    </van-search>
                </van-row>
                <div style="height: 320px; overflow: scroll;padding: 10px 10px 60px 10px;">

                    <van-row style="flex-wrap: wrap; margin: -6px;">

                        <div v-for="(gpline, index) in filterGplineList" :key="index" class="custom-checkbox" :class="{ 'checked': gpline.checked }" @click="selectCinemaFilterGplineCheck(index)" style="margin: 6px;font-size: small;">
                            {{ gpline.label }}
                        </div>
                    </van-row>
                </div>
                <van-row type="flex" class="bottom-row" justify="center" style="font-size: 12px;padding: 5px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
                    <!-- <van-col span="5">已选择{{selectCount}}个</van-col>
                    <van-col span="16" style="text-align: right;">
                        <van-button plain size="small" type="danger" @click="resetCity">重 置</van-button>
                        <van-button type="danger" size="small" style="margin-left: 40px;" @click="saveCity">确认选择</van-button>
                    </van-col> -->
                    <van-button plain size="small" type="danger" @click="resetFilterGpline">重 置</van-button>
                </van-row>
            </van-dropdown-item>
        </van-dropdown-menu>

        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入影院名" v-model="searchCinemaText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchCinemaText !== ''" name="clear" @click="clearCinemaClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchCinemaClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <div style="height: 420px; overflow: scroll;padding: 10px 10px 60px 10px;">
            <van-list v-model="loading" :error.sync="error" error-text="请求失败，点击重新加载" :offset="50" @load="onLoad">
                <div v-for="(cinema, index) in filterCinemaList" :key="index" style="padding: 5px; font-size: small;">
                    <van-checkbox v-model="cinema.checked" @click="toggleCinema(index)">{{ cinema.city_name }} · {{ cinema.name }}</van-checkbox>
                </div>
                <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
            </van-list>
            <!-- <van-row style="flex-wrap: wrap; margin: -8px;">
            
                                <div v-for="(gpline, index) in filterGplineList" :key="index" class="custom-checkbox" :class="{ 'checked': gpline.checked }" @click="selectCinemaFilterGplineCheck(index)" style="margin: 8px;">
                                    {{ gpline.label }} 
                                </div>
                            </van-row> -->
        </div>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="8">
                <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCinemaCount}}</span>个影院</span>
            </van-col>
            <van-col span="16" style="text-align: right;">
                <van-button plain size="small" type="default" @click="resetCinema">重 置</van-button>
                <van-button type="danger" size="small" style="margin-left: 20px;" @click="saveCinemaExclude">确认排除</van-button>
                <van-button type="primary" size="small" style="margin-left: 20px;" @click="saveCinema">确认选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!-- 影院分类弹窗 -->
    <van-popup v-model="selectClass" position="bottom" round class="class-popup">
        <div class="class-popup-head">
            <span class="class-popup-title">选择影院分类</span>
            <span class="class-popup-hint">已选 {{ filterClassList.filter(c => c.checked).length }} 项</span>
        </div>
        <div class="class-popup-body">
            <van-loading v-if="classListLoading" type="spinner" size="24px" vertical class="class-popup-loading">加载中</van-loading>
            <template v-else>
                <div
                    v-for="(item, index) in filterClassList"
                    :key="item.id"
                    class="class-popup-item"
                    :class="{ 'is-checked': item.checked }"
                    @click="toggleClassCheck(index)"
                >
                    <span class="class-popup-item-name">{{ item.name }}</span>
                    <van-icon v-if="item.checked" name="success" class="class-popup-item-icon" />
                </div>
                <div v-if="filterClassList.length === 0" class="class-popup-empty">暂无可选分类</div>
            </template>
        </div>
        <div class="class-popup-foot">
            <button type="button" class="class-popup-btn class-popup-btn--reset" @click="resetClass">重置</button>
            <button type="button" class="class-popup-btn class-popup-btn--exclude" @click="saveClassAsExclude">排除</button>
            <button type="button" class="class-popup-btn class-popup-btn--include" @click="saveClassAsInclude">包含</button>
        </div>
    </van-popup>

    <van-action-sheet v-model="showSelectCinema" :actions="selectCinemaList" description="已选中的影院" />

    <!--影厅弹窗-->
    <van-popup v-model="selectHall" round position="bottom">
        <!--弹框标题-->
        <div style="background-color: #f5f5f5;padding: 10px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <van-col span="24" style="text-align: center;">选择影厅</van-col>
            </van-row>
        </div>
        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入影厅名" v-model="searchText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchText !== ''" name="clear" @click="clearHallClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchHallClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <div style="height: 320px; overflow: scroll;padding: 10px 10px 60px 10px;">
            <van-row style="flex-wrap: wrap; margin: -6px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(hall, index) in filterHallList" :key="index" class="custom-checkbox" :class="{ 'checked': hall.checked }" @click="hallCheck(index)" style="margin: 6px;font-size: small;">
                    {{ hall.label }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="8">
                <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个影厅</span>
            </van-col>
            <van-col span="16" style="text-align: right;">
                <van-button plain size="small" type="default" @click="resetHall">重 置</van-button>
                <van-button type="danger" size="small" style="margin-left: 20px;" @click="saveHallExclude">确认排除</van-button>
                <van-button type="primary" size="small" style="margin-left: 20px;" @click="saveHall">确认选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!--影片弹窗-->
    <van-popup v-model="selectMovie" round position="bottom">
        <!--弹框标题-->
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <van-col span="24" style="text-align: center;">选择电影</van-col>
            </van-row>
        </div>
        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入影片名" v-model="searchText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchText !== ''" name="clear" @click="clearMovieClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchMovieClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <div style="height: 420px; overflow: scroll;padding: 10px 10px 60px 10px;">
            <van-row style="flex-wrap: wrap; margin: -8px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(movie, index) in filterMovieList" :key="index" class="custom-checkbox" :class="{ 'checked': movie.checked }" @click="movieCheck(index)" style="margin: 8px;font-size: small;">
                    {{ movie.label }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="8">
                <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个电影</span>
            </van-col>
            <van-col span="16" style="text-align: right;">
                <van-button plain size="small" type="default" @click="resetMovie">重 置</van-button>
                <van-button type="danger" size="small" style="margin-left: 20px;" @click="saveMovieExclude">确认排除</van-button>
                <van-button type="primary" size="small" style="margin-left: 20px;" @click="saveMovie">确认选择</van-button>
            </van-col>
        </van-row>
    </van-popup>
    <van-popup v-model="selectTime" round position="bottom">
        <van-datetime-picker style="height: 320px; overflow: scroll;padding: 10px 10px 15px 10px;" v-model="currentTime" type="time" :min-hour="0" :max-hour="23" @confirm="timeCheck" @cancel="selectTime = false" />
    </van-popup>

    <van-popup v-model="selectDate" round position="bottom">
        <van-datetime-picker style="height: 320px; overflow: scroll;padding: 10px 10px 15px 10px;" v-model="currentDate" type="date" @confirm="dateCheck" @cancel="selectData = false" />
    </van-popup>

    <!--星期弹窗-->
    <van-popup v-model="selectWeek" round position="bottom">
        <!--弹框标题-->
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <van-col span="24" style="text-align: center;">添加包含星期</van-col>
            </van-row>
        </div>
        <div style="height: 200px; overflow: scroll;padding: 10px 10px 15px 10px;">
            <van-row style="flex-wrap: wrap; margin: -8px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(week, index) in filterWeekList" :key="index" class="custom-checkbox" :class="{ 'checked': week.checked }" @click="weekCheck(index)" style="margin: 8px;font-size: small;">
                    {{ week.name }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="5">已选择{{selectCount}}个</van-col>
            <van-col span="16" style="text-align: right;">
                <van-button plain size="small" type="danger" @click="resetWeek">重 置</van-button>
                <van-button type="danger" size="small" style="margin-left: 40px;" @click="saveWeek">确认选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

</div>
</template>

<script>
import Api from '@/api-service'

import {
    Dialog
} from 'vant-green';

export default {
    name: "Rule-Custom",
    data() {
        return {
            configId: 0,
            configType: 4,
            copy: 0,

            ruleInfo: {
                // 省份 - 统一使用scope_type和scope字段
                province_scope_type: 1, // 1-不限，2-包含，3-排除
                province_scope: [],
                province_desc: '不限',

                // 城市 - 统一使用scope_type和scope字段
                city_scope_type: 1, // 1-不限，2-包含，3-排除
                city_scope: [],
                city_desc: '不限',

                // 院线
                gp_line: 0,
                line_name: '不限',
                gp_line_scope_type: 1, // 1-包含，2-排除
                gp_line_id: [], // 院线ID数组
                gp_line_desc: '不限',

                // 影院 - 统一使用scope_type和scope字段
                cinema_scope_type: 1, // 1-不限，2-包含，3-排除
                cinema_scope: [],
                cinema_desc: '不限',

                // 影院分类
                class_scope_type: 1, // 1-不限 2-包含 3-排除
                class_scope: [],
                class_desc: '不限',

                // 影厅 - 统一使用scope_type和scope字段
                hall_scope_type: 1, // 1-不限，2-包含，3-排除
                hall_scope: [],
                hall_desc: '不限',

                // 电影 - 统一使用scope_type和scope字段
                movie_scope_type: 1, // 1-不限，2-包含，3-排除
                movie_scope: [],
                movie_desc: '不限',

                // 保留原有字段用于兼容
                include_province_desc: '设置包含省',
                include_province_scope: [],
                exclude_province_desc: '设置不包含省',
                exclude_province_scope: [],
                include_city_desc: '设置包含城市',
                include_city_scope: [],
                exclude_city_desc: '设置不包含城市',
                exclude_city_scope: [],
                include_cinema_desc: '设置包含影院',
                include_cinema_scope: [],
                exclude_cinema_desc: '设置不包含影院',
                exclude_cinema_scope: [],
                include_hall_desc: '设置包含影厅',
                include_hall_scope: [],
                exclude_hall_desc: '设置不包含影厅',
                exclude_hall_scope: [],
                include_movie_desc: '设置包含影片',
                include_movie_scope: [],
                exclude_movie_desc: '设置不包含影片',
                exclude_movie_scope: [],

                begin_price: '',
                end_price: '',

                time_scope: [],
                begin_time: '',
                end_time: '',

                date_scope: [],
                begin_date: '',
                end_date: '',

                week_desc: '不限',
                week_days: [],

                ticket_num: [],

                // 情侣座规则
                seat_tag: '1', // '1'-包含情侣座，'2'-不包含情侣座

                // 报价类型
                bid_type: 6,
                bid_value: '',

                status: 1,
            },

            bid_type_desc: {
                3: '订单金额的百分比折扣，如填90，则为单价的9折进行自动报价',
                4: '当建议顶价为40时，如填2，则使用38自动报价，支持1位小数',
                5: '如填38，则使用38自动报价，支持1位小数',
                6: '当单价原价为40时，如填2，则使用38自动报价，支持1位小数',
            },

            selectProvince: false,
            selectCity: false,
            selectGpline: false,
            selectCinema: false,

            activeIndex: 0,
            provinceList: [],
            filterProvinceList: [],
            selectProvinceList: [],

            cityList: [],
            filterCityList: [],
            selectCityList: [],

            gpLineList: [],
            filterGplineList: [],
            selectedGpline: 0,

            // searchGplineList: [], // 搜索时，保存的gpLineList

            searchText: '',
            selectCount: 0,
            src: 0,

            // 院线范围类型选择
            gpLineScopeType: 1, // 1-包含，2-排除

            selectCinemaFilterCityNameList: [],
            // selectCinemaFilterCount: 0,
            selectCinemaFilterGplineList: [],
            selectCinemaFilterGplineCount: 0,

            searchCinemaText: '',
            cinemaList: [],
            filterCinemaList: [],
            selectCinemaList: [],
            selectCinemaNameList: [],
            selectCinemaCount: 0,
            page: 1,
            pageSize: 20,
            loading: false,
            error: false,
            finished: false,
            showSelectCinema: false,

            selectClass: false,
            filterClassList: [],
            classScopeType: 2,
            selectClassList: [],
            classListLoading: false,

            // selectCinemaFilterCityList: [],

            // selectCinemaCityList: [],
            selectCinemaCityCount: 0,

            selectHall: false,
            defaultHallList: [],
            selectHallList: [],
            filterHallList: [],

            // 影片
            selectMovie: false,
            movieList: [],
            selectMovieList: [],
            filterMovieList: [],

            // 时间
            selectTime: false,
            currentTime: '',

            // 日期
            selectDate: false,
            currentDate: '',

            // 星期
            selectWeek: false,
            weekList: [{
                    label: '星期一',
                    value: 1
                },
                {
                    label: '星期二',
                    value: 2
                },
                {
                    label: '星期三',
                    value: 3
                },
                {
                    label: '星期四',
                    value: 4
                },
                {
                    label: '星期五',
                    value: 5
                },
                {
                    label: '星期六',
                    value: 6
                },
                {
                    label: '星期日',
                    value: 7
                }
            ],
            selectWeekList: [],
            filterWeekList: [],
            inited: false,
            lastChecked: null,
        }
    },
    computed: {
        selectCinemaFilterCityText() {
            return `城市(${this.selectCinemaCityCount})`
        },
        selectCinemaFilterGplineText() {
            return `品牌(${this.selectCinemaFilterGplineCount})`
        },
        selectCinemaText() {
            return `已选择 ${this.selectCinemaCount} 个`
        },
        selectCinemaTitle() {
            if (this.src === 1) {
                return '添加包含影院'
            } else {
                return '添加不包含影院'
            }
        },
        selectHallTitle() {
            if (this.src === 1) {
                return '添加包含影厅'
            } else {
                return '添加不包含影厅'
            }
        },
        selectMovieTitle() {
            if (this.src === 1) {
                return '添加包含影片'
            } else {
                return '添加不包含影片'
            }
        },
        priceText(src) {
            if (src == 1) {
                if (this.ruleInfo.begin_price == '') {
                    return '最低'
                } else {
                    return this.ruleInfo.begin_price
                }
            } else {
                if (this.ruleInfo.end_price == '') {
                    return '最高'
                } else {
                    return this.ruleInfo.end_price
                }
            }
        },
        timeText(src) {
            if (src == 1) {
                if (this.ruleInfo.begin_price == '') {
                    return '开始'
                } else {
                    return this.ruleInfo.begin_price
                }
            } else {
                if (this.ruleInfo.end_price == '') {
                    return '结束'
                } else {
                    return this.ruleInfo.end_price
                }
            }
        },
        selectedTicketCountText() {
            if (!this.ruleInfo.ticket_num || this.ruleInfo.ticket_num.length === 0) {
                return '未选择';
            }
            
            // 处理"全部"选项的互斥逻辑
            let displayList = [...this.ruleInfo.ticket_num];
            if (displayList.includes(0)) {
                // 如果包含"全部"，只显示"全部"
                return '全部';
            }
            
            // 先复制数组再排序，避免修改原数组
            const sortedList = displayList.sort((a, b) => a - b);
            return sortedList.join('、') + '张';
        }
    },

    created() {
        this.configId = this.$route.query.id;
        this.configType = this.$route.query.type;
        this.copy = this.$route.query.copy;

        console.log(this.configId);
        
        // 确保 ticket_num 被正确初始化
        if (!this.ruleInfo.ticket_num || this.ruleInfo.ticket_num.length === 0) {
            this.ruleInfo.ticket_num = [0];
        }
        
        if (this.configId) {
            this.fetchData();
        }

        this.getProvince()
        this.getGpline()

        this.getCinema({
            page: this.page,
            pageSize: this.pageSize,
        })

        this.getHallList()
        this.getMovieList()
    },
    methods: {
        fetchData() {
            Api.getConfigDetail({
                id: this.configId
            }).then(res => {
                this.ruleInfo = res
                
                // 初始化省份统一字段
                if (this.ruleInfo.include_province_scope && this.ruleInfo.include_province_scope.length > 0) {
                    this.ruleInfo.province_scope_type = 2 // 包含
                    this.ruleInfo.province_scope = this.ruleInfo.include_province_scope
                    this.ruleInfo.province_desc =  '已包含' + this.ruleInfo.include_province_scope.length + '个省份'
                } else if (this.ruleInfo.exclude_province_scope && this.ruleInfo.exclude_province_scope.length > 0) {
                    this.ruleInfo.province_scope_type = 3 // 排除
                    this.ruleInfo.province_scope = this.ruleInfo.exclude_province_scope
                    this.ruleInfo.province_desc = '已排除' + this.ruleInfo.exclude_province_scope.length + '个省份'
                } else {
                    this.ruleInfo.province_scope_type = 1 // 不限
                    this.ruleInfo.province_scope = []
                    this.ruleInfo.province_desc = '不限'
                }

                // 初始化城市统一字段
                if (this.ruleInfo.include_city_scope && this.ruleInfo.include_city_scope.length > 0) {
                    this.ruleInfo.city_scope_type = 2 // 包含
                    this.ruleInfo.city_scope = this.ruleInfo.include_city_scope
                    this.ruleInfo.city_desc = '已包含' + this.ruleInfo.include_city_scope.length + '个城市'
                } else if (this.ruleInfo.exclude_city_scope && this.ruleInfo.exclude_city_scope.length > 0) {
                    this.ruleInfo.city_scope_type = 3 // 排除
                    this.ruleInfo.city_scope = this.ruleInfo.exclude_city_scope
                    this.ruleInfo.city_desc = '已排除' + this.ruleInfo.exclude_city_scope.length + '个城市'
                } else {
                    this.ruleInfo.city_scope_type = 1 // 不限
                    this.ruleInfo.city_scope = []
                    this.ruleInfo.city_desc = '不限'
                }

                // 初始化影院统一字段
                if (this.ruleInfo.include_cinema_scope && this.ruleInfo.include_cinema_scope.length > 0) {
                    this.ruleInfo.cinema_scope_type = 2 // 包含
                    this.ruleInfo.cinema_scope = this.ruleInfo.include_cinema_scope
                    this.ruleInfo.cinema_desc = '已包含' + this.ruleInfo.include_cinema_scope.length + '个影院'
                } else if (this.ruleInfo.exclude_cinema_scope && this.ruleInfo.exclude_cinema_scope.length > 0) {
                    this.ruleInfo.cinema_scope_type = 3 // 排除
                    this.ruleInfo.cinema_scope = this.ruleInfo.exclude_cinema_scope
                    this.ruleInfo.cinema_desc = '已排除' + this.ruleInfo.exclude_cinema_scope.length + '个影院'
                } else {
                    this.ruleInfo.cinema_scope_type = 1 // 不限
                    this.ruleInfo.cinema_scope = []
                    this.ruleInfo.cinema_desc = '不限'
                }

                // 初始化影院分类（后端返回 class_scope、class_scope_type，可能还有 select_class_list）
                const classScope = Array.isArray(this.ruleInfo.class_scope) ? this.ruleInfo.class_scope.map(Number) : []
                const classScopeType = this.ruleInfo.class_scope_type !== undefined && this.ruleInfo.class_scope_type !== null ? Number(this.ruleInfo.class_scope_type) : 1
                this.ruleInfo.class_scope_type = classScopeType
                this.ruleInfo.class_scope = classScope
                if (classScope.length > 0) {
                    this.ruleInfo.class_desc = classScopeType === 2 ? '已包含' + classScope.length + '个分类' : (classScopeType === 3 ? '已排除' + classScope.length + '个分类' : '不限')
                } else {
                    this.ruleInfo.class_desc = '不限'
                }

                // 初始化影厅统一字段
                if (this.ruleInfo.include_hall_scope && this.ruleInfo.include_hall_scope.length > 0) {
                    this.ruleInfo.hall_scope_type = 2 // 包含
                    this.ruleInfo.hall_scope = this.ruleInfo.include_hall_scope
                    this.ruleInfo.hall_desc = '已包含' + this.ruleInfo.include_hall_scope.length + '个影厅'
                } else if (this.ruleInfo.exclude_hall_scope && this.ruleInfo.exclude_hall_scope.length > 0) {
                    this.ruleInfo.hall_scope_type = 3 // 排除
                    this.ruleInfo.hall_scope = this.ruleInfo.exclude_hall_scope
                    this.ruleInfo.hall_desc = '已排除' + this.ruleInfo.exclude_hall_scope.length + '个影厅'
                } else {
                    this.ruleInfo.hall_scope_type = 1 // 不限
                    this.ruleInfo.hall_scope = []
                    this.ruleInfo.hall_desc = '不限'
                }

                // 初始化电影统一字段
                if (this.ruleInfo.include_movie_scope && this.ruleInfo.include_movie_scope.length > 0) {
                    this.ruleInfo.movie_scope_type = 2 // 包含
                    this.ruleInfo.movie_scope = this.ruleInfo.include_movie_scope
                    this.ruleInfo.movie_desc = '已包含' + this.ruleInfo.include_movie_scope.length + '个电影'
                } else if (this.ruleInfo.exclude_movie_scope && this.ruleInfo.exclude_movie_scope.length > 0) {
                    this.ruleInfo.movie_scope_type = 3 // 排除
                    this.ruleInfo.movie_scope = this.ruleInfo.exclude_movie_scope
                    this.ruleInfo.movie_desc = '已排除' + this.ruleInfo.exclude_movie_scope.length + '个电影'
                } else {
                    this.ruleInfo.movie_scope_type = 1 // 不限
                    this.ruleInfo.movie_scope = []
                    this.ruleInfo.movie_desc = '不限'
                }

                
                // 星期
                if (this.ruleInfo.week_days !== null && this.ruleInfo.week_days.length > 0) {
                    this.ruleInfo.week_desc = this.ruleInfo.week_days.join('、')
                } else {
                    this.ruleInfo.week_desc = '设置包含星期'
                }

                this.ruleInfo.bid_type = parseInt(this.ruleInfo.bid_type, 10);

                if (this.ruleInfo.line_name === '-') {
                    this.ruleInfo.line_name = '请选择包含品牌'
                }

                // 处理新版本字段的初始化
                // 处理院线范围字段 - 支持后台返回gp_line_id数组
                if (this.ruleInfo.gp_line_id && Array.isArray(this.ruleInfo.gp_line_id)) {
                    // 后台返回gp_line_id数组，直接使用
                    this.ruleInfo.gp_line_id = [...this.ruleInfo.gp_line_id]
                } else if (!this.ruleInfo.gp_line_id) {
                    this.ruleInfo.gp_line_id = []
                }

                // 处理座位数列表字段
                if (this.ruleInfo.ticket_num && this.ruleInfo.ticket_num.length > 0) {
                    // 如果ticket_num为空，但ticket_num有值，使用ticket_num
                    this.ruleInfo.ticket_num = [...this.ruleInfo.ticket_num]
                } else if (!this.ruleInfo.ticket_num) {
                    this.ruleInfo.ticket_num = [0]
                }

                // 处理情侣座字段
                if (this.ruleInfo.seat_tag === undefined || this.ruleInfo.seat_tag === null) {
                    this.ruleInfo.seat_tag = '1' // 默认包含情侣座
                }


                // 处理时间范围字段
                if (this.ruleInfo.time_scope && this.ruleInfo.time_scope.length >= 2) {
                    this.ruleInfo.begin_time = this.ruleInfo.time_scope[0] || ''
                    this.ruleInfo.end_time = this.ruleInfo.time_scope[1] || ''
                }
                
                // 处理日期范围字段
                if (this.ruleInfo.date_scope && this.ruleInfo.date_scope.length >= 2) {
                    this.ruleInfo.begin_date = this.ruleInfo.date_scope[0] || ''
                    this.ruleInfo.end_date = this.ruleInfo.date_scope[1] || ''
                }

                                 // 设置院线范围描述
                 if (this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.length > 0) {
                     const scopeType = this.ruleInfo.gp_line_scope_type === 2 ? '已选择' : '已排除'
                     this.ruleInfo.gp_line_desc = `${scopeType}${this.ruleInfo.gp_line_id.length}个院线`
                 } else {
                     this.ruleInfo.gp_line_desc = '不限'
                 }

                console.log(this.ruleInfo)
                if (this.copy) {
                    // 名字加上1。id置空
                    this.ruleInfo.name += (复制)
                    this.configId = 0
                }

            })
        },
        getProvince() {
            Api.getProvinceCityList({}).then(res => {
                this.provinceList = res.list.map(el => {
                    return {
                        label: el.name,
                        value: el.id,
                        checked: false,
                    }
                })
                this.cityList = res.list
                this.filterCityList = res.list
            })
        },
        getGpline() {
            Api.getGpLineList({}).then(res => {
                this.gpLineList = res.list.map(el => {
                    return {
                        label: el.name,
                        value: el.ID,
                        checked: false,
                    }
                })
                // 初始化filterGplineList
                this.filterGplineList = [...this.gpLineList]
            })
        },
        getCinema(data) {
            console.log(data)
            Api.getCinemaList(data).then(res => {
                this.cinemaList = res.list.map(el => {
                    return {
                        name: el.name,
                        city_name: el.city_name,
                        id: el.ID,
                        checked: false,
                    }
                })
            })
        },
        getHallList(data) {
            Api.getDefaultHallList(data).then(res => {
                this.defaultHallList = res.map(el => {
                    return {
                        name: el.name,
                    }
                })
            })
        },
        getMovieList() {
            const data = {
                'pageSize': 100,
                'page': 1,
                'orderKey': 'created_at',
                'desc': true
            }
            Api.getMovieList(data).then(res => {
                this.movieList = res.list.map(el => {
                    return {
                        name: el.name,
                        id: el.ID,
                        checked: false,
                    }
                })
            })
        },
        setStatus(checked) {
            if (checked) {
                this.ruleInfo.status = 1;
            } else {
                this.ruleInfo.status = 2;
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        deleteRule() {
            Dialog.confirm({
                    message: '确认删除报价方案？'
                })
                .then(() => {
                    Api.deleteConfig({
                        id: this.ruleInfo.id
                    }).then(res => {
                        this.goBack()
                    })
                })
                .catch(() => {
                    // on cancel
                });
        },
        showProvinceSelect() {
            this.selectProvince = true;
            this.selectCount = 0;
            this.selectProvinceList = []
            this.filterProvinceList = []

            let curProvinceList = this.ruleInfo.province_scope || [];
            console.log(curProvinceList)
            console.log(this.provinceList)
            this.provinceList.forEach(item => {
                // item.value是否在this.ruleInfo.include_province_scope中，
                let checked = false
                if (curProvinceList != null && curProvinceList.indexOf(item.value) != -1) {
                    checked = true;
                    console.log('not in')
                    this.selectCount++;
                    this.selectProvinceList.push({
                        label: item.label,
                        value: item.value,
                    })
                }

                this.filterProvinceList.push({
                    label: item.label,
                    value: item.value,
                    checked: checked,
                })
                /*
                if (this.selectProvinces.indexOf(item.value) != -1 && item.checked) {
                    item.checked = true;
                    this.selectCount++;
                } else {
                    item.checked = false;
                }
                */
            })
            console.log(this.filterProvinceList)
        },
        provinceCheck(index) {
            // console.log(this.filterProvinceList[index].checked)
            this.filterProvinceList[index].checked = !this.filterProvinceList[index].checked;
            if (this.filterProvinceList[index].checked) {
                this.selectProvinceList.push(this.filterProvinceList[index])
                this.selectCount++
            } else {
                this.selectProvinceList.forEach((item, index1) => {
                    if (item.value === this.filterProvinceList[index].value) {
                        this.selectProvinceList.splice(index1, 1)
                    }
                })
                this.selectCount--
            }

        },
        resetProvince() {
            this.filterProvinceList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.selectProvinceList = []
            this.selectCount = 0
        },
        searchProvinceClick() {
            if (this.searchText) {
                this.filterProvinceList.filter(item => {
                    return item.label.indexOf(this.searchText) != -1
                })

            }
        },
        saveProvince() {
            // 保存为包含模式
            let provinceName = ''
            let provinceId = []
            this.selectProvinceList.forEach(item => {
                provinceName += item.label + ','
                provinceId.push(item.value)
            })

            if (provinceName === '') {
                provinceName = '请选择省份范围'
            } else {
                provinceName = '已包含' + this.selectCount + '个省份'
            }
            
            this.ruleInfo.province_scope_type = 2 // 包含
            this.ruleInfo.province_scope = provinceId
            this.ruleInfo.province_desc = provinceName

            this.selectProvince = false
        },
        
        saveProvinceExclude() {
            // 保存为排除模式
            let provinceName = ''
            let provinceId = []
            this.selectProvinceList.forEach(item => {
                provinceName += item.label + ','
                provinceId.push(item.value)
            })

            if (provinceName === '') {
                provinceName = '请选择省份范围'
            } else {
                provinceName = '已排除' + this.selectCount + '个省份'
            }
            
            this.ruleInfo.province_scope_type = 3 // 排除
            this.ruleInfo.province_scope = provinceId
            this.ruleInfo.province_desc = provinceName

            this.selectProvince = false
        },
        clearProvinceClick() {
            // 清除省份搜索
            this.searchText = '';
            // this.filterGplineList = this.gplineList;
            this.filterGplineList = []

            this.provinceList.forEach(item => {
                // item.value是否在this.ruleInfo.include_province_scope中，
                let checked = false
                // 判断是否在选中省份中

                this.selectProvinceList.forEach(item2 => {
                    if (item2.value === item.value) {
                        checked = true;
                        return
                    }
                })

                this.filterProvinceList.push({
                    label: item.label,
                    value: item.value,
                    checked: checked,
                })
            })
        },

        showCitySelect() {
            console.log('showCitySelect')
            this.selectCount = 0;
            this.selectCityList = []
            this.filterCityList = []

            let curCityList = this.ruleInfo.city_scope || [];

            console.log(curCityList)
            console.log(this.cityList)
            this.cityList.forEach((item, index) => {
                let info = ''
                let arrCity = []
                item.city_list.forEach(itemCity => {
                    // item.value是否在this.ruleInfo.exclude_city_scope中，
                    // console.log(itemCity.ID, curCityList)
                    let checked = false
                    // console.log(checked)
                    if (curCityList != null) {
                        curCityList.forEach(item1 => {
                            console.log(item1, itemCity.ID)
                            if (item1 === itemCity.city_code) {
                                checked = true;
                                this.selectCount++;
                                if (info == '') {
                                    info = 1
                                } else {
                                    info++
                                }
                                if (this.activeIndex == 0) {
                                    this.activeIndex = index
                                }
                                return
                            }
                        })
                    }

                    if (checked) {
                        this.selectCityList.push({
                            name: itemCity.name,
                            id: itemCity.ID,
                            city_code: itemCity.city_code
                        })
                    }
                    arrCity.push({
                        name: itemCity.name,
                        id: itemCity.ID,
                        city_code: itemCity.city_code,
                        checked: checked
                    })
                })

                this.filterCityList.push({
                    text: item.name,
                    info: info,
                    city_list: arrCity
                })
            })

            console.log(this.filterCityList)
            this.selectCity = true;

        },
        toggleCity(index) {

            // if (this.filterCityList[this.activeIndex].city_list[index].checked) {
            //     console.log('not in222')
            //     this.filterCityList[this.activeIndex].city_list[index].checked = false
            // }else {
            //     console.log('not in')
            //     this.filterCityList[this.activeIndex].city_list[index].checked = true
            // }
            // this.filterCityList[this.activeIndex].city_list[index].checked = !this.filterCityList[this.activeIndex].city_list[index].checked;
            console.log(this.filterCityList[this.activeIndex].city_list[index])
            if (this.filterCityList[this.activeIndex].city_list[index].checked) {
                this.selectCount++
                if (this.filterCityList[this.activeIndex].info == '') {
                    this.filterCityList[this.activeIndex].info = 1
                } else {
                    this.filterCityList[this.activeIndex].info++
                }

                // 添加选中的城市
                this.selectCityList.push({
                    name: this.filterCityList[this.activeIndex].city_list[index].name,
                    id: this.filterCityList[this.activeIndex].city_list[index].id,
                    city_code: this.filterCityList[this.activeIndex].city_list[index].city_code
                })

            } else {
                this.selectCount--
                this.filterCityList[this.activeIndex].info--

                // 删除已选
                for (let i = 0; i < this.selectCityList.length; i++) {
                    if (this.selectCityList[i].id == this.filterCityList[this.activeIndex].city_list[index].id) {
                        this.selectCityList.splice(i, 1)
                        break
                    }
                }
            }
        },
        resetCity() {
            this.filterCityList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.info = '';
                item.city_list.forEach(item => {
                    item.checked = false;
                })
            })
            this.selectCount = 0
            this.selectCityList = []
        },
        saveCity() {
            // let data = []
            // this.filterCityList.forEach(item => {
            //     // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
            //     item.city_list.forEach(item => {
            //         if (item.checked) {
            //             data.push(item)
            //         }

            //     })
            // })

            // 保存为包含模式
            let cityName = ''
            let cityId = []
            this.selectCityList.forEach(item => {
                cityName += item.name + ','
                cityId.push(item.city_code)
            })
            console.log(cityId)
            console.log(this.selectCityList)
            if (cityName === '') {
                cityName = '请选择城市范围'
            } else {
                cityName = '已包含' + this.selectCount + '个城市'
            }
            
            this.ruleInfo.city_scope_type = 2 // 包含
            this.ruleInfo.city_scope = cityId
            this.ruleInfo.city_desc = cityName

            this.selectCity = false
        },
        
        saveCityExclude() {
            // 保存为排除模式
            let cityName = ''
            let cityId = []
            this.selectCityList.forEach(item => {
                cityName += item.name + ','
                cityId.push(item.city_code)
            })

            if (cityName === '') {
                cityName = '请选择城市范围'
            } else {
                cityName = '已排除' + this.selectCount + '个城市'
            }
            
            this.ruleInfo.city_scope_type = 3 // 排除
            this.ruleInfo.city_scope = cityId
            this.ruleInfo.city_desc = cityName

            this.selectCity = false
        },
        clearCityClick() {
            this.searchText = '';
            // this.filterGplineList = this.gplineList;
            this.filterCityList = []
            this.activeIndex == 0
            this.selectCount = 0

            this.cityList.forEach((item, index) => {
                let info = ''
                let arrCity = []
                item.city_list.forEach(itemCity => {
                    // item.value是否在this.ruleInfo.exclude_city_scope中，
                    console.log(itemCity.ID, this.selectCityList)
                    let checked = false
                    console.log(checked)
                    this.selectCityList.forEach(item1 => {
                        console.log(item1, itemCity.ID)
                        if (item1.id === itemCity.ID) {
                            checked = true;
                            this.selectCount++;
                            if (info == '') {
                                info = 1
                            } else {
                                info++
                            }
                            if (this.activeIndex == 0) {
                                this.activeIndex = index
                            }
                            return
                        }
                    })

                    arrCity.push({
                        name: itemCity.name,
                        id: itemCity.ID,
                        city_code: itemCity.city_code,
                        checked: checked
                    })
                })

                this.filterCityList.push({
                    text: item.name,
                    info: info,
                    city_list: arrCity
                })
            })
        },
        searchCityClick() {
            console.log(this.searchText)
            if (this.searchText) {
                // this.selectCity = false
                this.filterCityList = []
                this.activeIndex == 0
                this.cityList.forEach((item, index) => {
                    let info = ''
                    let arrCity = []
                    let checked = false
                    item.city_list.forEach(itemCity => {
                        // item.value是否在this.ruleInfo.exclude_city_scope中，
                        // console.log(this.searchText, itemCity.name)

                        // console.log(checked)
                        if (itemCity.name.indexOf(this.searchText) !== -1) {
                            checked = true;
                            if (info == '') {
                                info = 1
                            } else {
                                info++
                            }
                            if (this.activeIndex == 0) {
                                this.activeIndex = index
                            }
                        }

                        arrCity.push({
                            name: itemCity.name,
                            id: itemCity.ID,
                            checked: false,
                            city_code: itemCity.city_code
                        })
                        // if (checked) {
                        //     arrCity.push({
                        //         name: itemCity.name,
                        //         id: itemCity.ID,
                        //         checked: false,
                        //         city_code: itemCity.city_code
                        //     })
                        // }else {
                        //     arrCity.push({
                        //         name: itemCity.name,
                        //         id: itemCity.ID,
                        //         checked: false,
                        //         city_code: itemCity.city_code
                        //     })
                        // }

                    })
                    // console.log(arrCity)
                    // if (arrCity.length > 0) {
                    this.filterCityList.push({
                        text: item.name,
                        // info: info,
                        city_list: arrCity,
                        dot: checked ? true : false

                    })
                    // }
                    // return

                })
                this.filterCityList.sort((a, b) => b.dot - a.dot)
                this.activeIndex = 0
                console.log(this.filterCityList)
                // this.selectCity = true
            }
        },

        showGplineSelect(isSingle = false) {
            this.src = isSingle ? 1 : 2
            this.selectGpline = true
            this.searchText = ''
            this.selectCount = 0

            // 重置选择状态
            this.filterGplineList.forEach(item => {
                item.checked = false
            })

            // 如果是单选模式，设置已选择的院线
            if (isSingle && this.ruleInfo.gp_line > 0) {
                this.filterGplineList.forEach(item => {
                    if (item.value === this.ruleInfo.gp_line) {
                        item.checked = true
                        this.selectCount = 1
                    }
                })
            } else if (!isSingle && this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.length > 0) {
                // 多选模式，设置已选择的院线
                this.gpLineScopeType = this.ruleInfo.gp_line_scope_type
                this.filterGplineList.forEach(item => {
                    if (this.ruleInfo.gp_line_id.includes(item.value)) {
                        item.checked = true
                        this.selectCount++
                    }
                })
            }
        },
        gplineCheck(index) {
            this.filterGplineList[index].checked = !this.filterGplineList[index].checked;
            if (this.filterGplineList[index].checked) {
                this.selectCount++
            } else {
                this.selectCount--
            }
        },
        searchGplineClick() {
            if (this.searchText) {
                this.filterGplineList = []

                this.gpLineList.forEach(item => {
                    if (item.label.indexOf(this.searchText) !== -1) {
                        let checked = false
                        if (this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.includes(item.value)) {
                            checked = true;
                        }
                        this.filterGplineList.push({
                            label: item.label,
                            value: item.value,
                            checked: checked
                        })
                    }
                })
                console.log(this.filterGplineList)
            }
        },
        clearGplineClick() {
            this.searchText = '';
            this.filterGplineList = []

            this.gpLineList.forEach(item => {
                let checked = false
                if (this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.includes(item.value)) {
                    checked = true;
                }
                this.filterGplineList.push({
                    label: item.label,
                    value: item.value,
                    checked: checked
                })
            })
        },
        resetGpline() {
            this.filterGplineList.forEach(item => {
                item.checked = false;
            })
            this.selectCount = 0
        },
        saveGpline() {
            if (this.src === 1) {
                // 单选模式（兼容老版本）
                this.ruleInfo.gp_line = this.selectedGpline;
                this.ruleInfo.line_name = this.filterGplineList[this.selectedGpline].label;
            } else {
                // 多选模式（新版本）
                let selectedGplines = []
                let selectedNames = []
                
                this.filterGplineList.forEach(item => {
                    if (item.checked) {
                        selectedGplines.push(item.value)
                        selectedNames.push(item.label)
                    }
                })
                
                                 this.ruleInfo.gp_line_id = selectedGplines
                 this.ruleInfo.gp_line_scope_type = 2 // 设置为包含类型
                
                if (selectedNames.length > 0) {
                    this.ruleInfo.gp_line_desc = `已选择${selectedNames.length}个院线`
                } else {
                    this.ruleInfo.gp_line_desc = '请选择院线范围'
                }
            }
            // 强制刷新（如有响应式问题）
            this.$forceUpdate && this.$forceUpdate();
            this.selectGpline = false;
        },

        saveGplineExclude() {
            if (this.src === 1) {
                // 单选模式（兼容老版本）
                this.ruleInfo.gp_line = this.selectedGpline;
                this.ruleInfo.line_name = this.filterGplineList[this.selectedGpline].label;
            } else {
                // 多选模式（新版本）
                let selectedGplines = []
                let selectedNames = []
                
                this.filterGplineList.forEach(item => {
                    if (item.checked) {
                        selectedGplines.push(item.value)
                        selectedNames.push(item.label)
                    }
                })
                
                                 this.ruleInfo.gp_line_id = selectedGplines
                 this.ruleInfo.gp_line_scope_type = 3 // 设置为排除类型
                
                if (selectedNames.length > 0) {
                    this.ruleInfo.gp_line_desc = `已排除${selectedNames.length}个院线`
                } else {
                    this.ruleInfo.gp_line_desc = '请选择院线范围'
                }
            }
            // 强制刷新（如有响应式问题）
            this.$forceUpdate && this.$forceUpdate();
            this.selectGpline = false;
        },

        // 获取院线显示颜色
        getGplineColor() {
            if (!this.ruleInfo.gp_line_id || this.ruleInfo.gp_line_id.length === 0) {
                return '#666666'; // 默认灰色
            }
            return this.ruleInfo.gp_line_scope_type === 2 ? '#ff2c54' : '#07c160'; // 排除红色，选择绿色
        },

                 // 获取院线显示颜色类名
         getGplineColorClass() {
             if (!this.ruleInfo.gp_line_id || this.ruleInfo.gp_line_id.length === 0) {
                 return ''; // 无特殊颜色
             }
             return this.ruleInfo.gp_line_scope_type === 3 ? 'gpline-exclude' : 'gpline-include'; // 排除红色，选择绿色
         },

        // 获取省份显示颜色类名
        getProvinceColorClass() {
            if (!this.ruleInfo.province_scope || this.ruleInfo.province_scope.length === 0) {
                return ''; // 无特殊颜色
            }
            return this.ruleInfo.province_scope_type === 3 ? 'province-exclude' : 'province-include'; // 排除红色，选择绿色
        },

        // 获取城市显示颜色类名
        getCityColorClass() {
            if (!this.ruleInfo.city_scope || this.ruleInfo.city_scope.length === 0) {
                return ''; // 无特殊颜色
            }
            return this.ruleInfo.city_scope_type === 3 ? 'city-exclude' : 'city-include'; // 排除红色，选择绿色
        },

        // 获取影院显示颜色类名
        getCinemaColorClass() {
            if (!this.ruleInfo.cinema_scope || this.ruleInfo.cinema_scope.length === 0) {
                return ''; // 无特殊颜色
            }
            return this.ruleInfo.cinema_scope_type === 3 ? 'cinema-exclude' : 'cinema-include'; // 排除红色，选择绿色
        },

        getClassColorClass() {
            const hasClass = this.ruleInfo.class_scope && this.ruleInfo.class_scope.length > 0
            if (!hasClass) return ''
            return this.ruleInfo.class_scope_type === 3 ? 'class-exclude' : 'class-include'
        },

        showClassSelect() {
            this.selectClass = true
            this.classScopeType = (this.ruleInfo.class_scope_type === 3) ? 3 : 2
            this.classListLoading = true
            Api.getCinemaClassSelectList()
                .then(res => {
                    const list = (res && res.list) || (res && res.data && res.data.list) || []
                    const arr = Array.isArray(list) ? list : []
                    const curIds = new Set((this.ruleInfo.class_scope || []).map(Number))
                    this.filterClassList = arr.map(item => ({
                        id: item.id,
                        name: item.name || item.label,
                        checked: curIds.has(Number(item.id))
                    }))
                    this.selectClassList = this.filterClassList.filter(c => c.checked).map(c => c.id)
                })
                .catch(() => {
                    this.$toast.fail('加载可选分类失败')
                    this.filterClassList = []
                    this.selectClassList = []
                })
                .finally(() => {
                    this.classListLoading = false
                })
        },
        toggleClassCheck(index) {
            const item = this.filterClassList[index]
            if (!item) return
            item.checked = !item.checked
            this.selectClassList = this.filterClassList.filter(c => c.checked).map(c => c.id)
        },
        resetClass() {
            this.filterClassList.forEach(c => { c.checked = false })
            this.selectClassList = []
        },
        saveClassAsInclude() {
            this.classScopeType = 2
            this.saveClass()
        },
        saveClassAsExclude() {
            this.classScopeType = 3
            this.saveClass()
        },
        saveClass() {
            const ids = this.filterClassList.filter(c => c.checked).map(c => Number(c.id))
            this.ruleInfo.class_scope_type = this.classScopeType
            this.ruleInfo.class_scope = ids
            if (ids.length > 0) {
                this.ruleInfo.class_desc = this.classScopeType === 2 ? '已包含' + ids.length + '个分类' : '已排除' + ids.length + '个分类'
            } else {
                this.ruleInfo.class_desc = '不限'
                this.ruleInfo.class_scope_type = 1
            }
            this.selectClass = false
        },

        // 获取影厅显示颜色类名
        getHallColorClass() {
            if (!this.ruleInfo.hall_scope || this.ruleInfo.hall_scope.length === 0) {
                return ''; // 无特殊颜色
            }
            return this.ruleInfo.hall_scope_type === 3 ? 'hall-exclude' : 'hall-include'; // 排除红色，选择绿色
        },

        // 获取电影显示颜色类名
        getMovieColorClass() {
            if (!this.ruleInfo.movie_scope || this.ruleInfo.movie_scope.length === 0) {
                return ''; // 无特殊颜色
            }
            return this.ruleInfo.movie_scope_type === 3 ? 'movie-exclude' : 'movie-include'; // 排除红色，选择绿色
        },


        showCinemaSelect() {
            console.log('showCinemaSelect')
            this.selectCount = 0;
            this.selectCinemaCount = 0;
            this.selectedGpline = 0;
            this.searchCinemaText = '';
            this.selectCinemaList = this.ruleInfo.select_cinema;
            this.filterCinemaList = []

            let curCinemaList = this.ruleInfo.cinema_scope || [];
            console.log(this.selectCinemaList)

            if (curCinemaList != null) {
                this.selectCinemaCount = curCinemaList.length
            }

            console.log(curCinemaList)

            // this.selectCinemaList = curCinemaList
            // if (this.ruleInfo.cinema_desc != '') {
            //     // 分割,
            //     this.selectCinemaNameList = this.ruleInfo.cinema_desc.split(',')
            // }
            // this.selectCinemaCount = this.selectCinemaNameList.length

            // 处理列表中的影院
            this.cinemaList.forEach(item => {
                let checked = false
                if (curCinemaList != null && curCinemaList.indexOf(item.id) != -1) {
                    checked = true;
                }

                // if (checked) {
                //     this.selectCinemaCount++
                //     this.selectCinemaList.push({
                //         name: item.name,
                //         city_name: item.city_name,
                //         id: item.id,
                //     })
                // }
                this.filterCinemaList.push({
                    name: item.name,
                    city_name: item.city_name,
                    id: item.id,
                    checked: checked,
                })
            })
            console.log(this.filterCinemaList)
            // this.showCitySelect(src, false)
            // this.showGplineSelect(false)

            // 判断filterCinemaList中是否有selectCinemaList的影院，如果有checked设置true
            if (this.selectCinemaList != null) {
                this.selectCinemaList.forEach(item => {
                    let checked = false
                    this.filterCinemaList.forEach(item2 => {
                        if (item.id === item2.id) {
                            checked = true;
                            // this.selectCinemaCount++
                        }
                    })
                    if (!checked) {
                        // 添加到filterCinemaList的第一个位置
                        this.filterCinemaList.unshift({
                            name: item.name,
                            city_name: item.city_name,
                            id: item.id,
                            checked: true,
                        })
                    }

                })
            }

            console.log(this.filterCinemaList)
            this.selectCinema = true;
        },
        resetFilterCity() {
            // 筛选城市，保存
            this.resetCity()
            this.selectCinemaCityCount = this.selectCount;
        },
        saveFiterCity() {
            console.log('saveFiterCity')
            this.selectCinemaCityCount = this.selectCount;
            this.$refs.selectCinemafilterCity.toggle(false)
            // 保存筛选的城市，并重新查询影院列表
            this.getCinemaByFitler(true)
            this.loading = false

        },
        selectCinemaFilterGplineCheck(index) {

            console.log(this.filterGplineList[index])
            this.filterGplineList.forEach(item => {
                item.checked = false
            })
            this.filterGplineList[index].checked = true
            this.selectCinemaFilterGplineCount = 1
            this.$refs.selectCinemafilterGpline.toggle(false)
            this.selectCity = false
            this.selectGpline = false;
            this.selectedGpline = this.filterGplineList[index].value;
            // 保存筛选品牌，并重新查询影院列表
            // this.ruleInfo.gp_line = this.filterGplineList[index].value;
            // this.ruleInfo.line_name = this.filterGplineList[index].label;
            this.getCinemaByFitler(true)
            this.loading = false
        },
        // filterGplineCheck(index) {
        //     this.selectedGpline = this.filterGplineList[index].value;

        //     this.selectGpline = false;
        // },
        resetFilterGpline() {
            this.selectedGpline = 0;
            this.selectCinemaFilterGplineCount = 0;
            this.filterGplineList.forEach(item => {
                item.checked = false
            })
            this.$refs.selectCinemafilterGpline.toggle(false)
            this.selectGpline = false;
            this.getCinemaByFitler(true)
        },
        clearCinemaClick() {
            // 清除搜索
            this.searchCinemaText = ''
            this.getCinemaByFitler(true)
        },
        searchCinemaClick() {
            this.getCinemaByFitler(true)
        },
        getCinemaByFitler(refresh) {
            let cityId = ''
            this.selectCityList.forEach(item => {
                // cityName += item.name + ','
                if (cityId !== '') {
                    cityId += ','
                }
                cityId += item.city_code
            })
            if (refresh) {
                this.page = 1
            } else {
                this.page++
            }
            let data = {
                page: this.page,
                pageSize: this.pageSize,
                // city_codes: cityId,
                line_id: this.selectedGpline,
                name: this.searchCinemaText
            }

            if (cityId.length > 0) {
                data.city_codes = cityId
            }

            Api.getCinemaList(data).then(res => {
                this.filterCinemaList = []

                let list = res.list.map(el => {
                    return {
                        name: el.name,
                        city_name: el.city_name,
                        id: el.ID,
                        checked: false,
                    }
                })

                if (refresh) {
                    this.cinemaList = list
                } else {
                    this.cinemaList = this.cinemaList.concat(list)
                }

                if (this.cinemaList.length >= res.total) {
                    this.finished = true
                }

                console.log(this.cinemaList)
                console.log(this.selectCinemaList)

                // 处理列表中的影院
                this.cinemaList.forEach(item => {
                    let checked = false
                    if (this.selectCinemaList != null) {
                        this.selectCinemaList.forEach(item2 => {
                            if (item2.id == item.id) {
                                checked = true;
                                return
                            }
                        })
                    }

                    this.filterCinemaList.push({
                        name: item.name,
                        city_name: item.city_name,
                        id: item.id,
                        checked: checked,
                    })
                })

                // 判断filterCinemaList中是否有selectCinemaList的影院，如果有checked设置true
                if (this.selectCinemaList != null) {
                    this.selectCinemaList.forEach(item => {
                        let checked = false
                        this.filterCinemaList.forEach(item2 => {
                            if (item.id === item2.id) {
                                checked = true;
                                return
                                // this.selectCinemaCount++
                            }
                        })
                        if (!checked) {
                            // 添加到filterCinemaList的第一个位置
                            this.filterCinemaList.unshift({
                                name: item.name,
                                city_name: item.city_name,
                                id: item.id,
                                checked: true,
                            })
                        }

                    })
                }

                console.log(this.filterCinemaList)

            })

        },
        onLoad() {
            console.log('onLoad')
            this.getCinemaByFitler(false)
            this.loading = false
        },
        toggleCinema(index) {
            // 勾选影院
            if(this.selectCinemaList == null) {
                this.selectCinemaList = []
            }
            console.log(this.selectCinemaList)

            // if (this.filterCityList[this.activeIndex].city_list[index].checked) {
            //     console.log('not in222')
            //     this.filterCityList[this.activeIndex].city_list[index].checked = false
            // }else {
            //     console.log('not in')
            //     this.filterCityList[this.activeIndex].city_list[index].checked = true
            // }
            // this.filterCityList[this.activeIndex].city_list[index].checked = !this.filterCityList[this.activeIndex].city_list[index].checked;
            console.log(this.filterCinemaList[index])
            if (this.filterCinemaList[index].checked) {
                // this.selectCinemaCount++

                // 添加选中的城市
                this.selectCinemaList.push({
                    name: this.filterCinemaList[index].name,
                    id: this.filterCinemaList[index].id,
                    city_name: this.filterCinemaList[index].city_name,
                })

            } else {

                // 删除已选
                for (let i = 0; i < this.selectCinemaList.length; i++) {
                    if (this.selectCinemaList[i].id == this.filterCinemaList[index].id) {
                        this.selectCinemaList.splice(i, 1)
                        break
                    }
                }
            }

            this.selectCinemaCount = this.selectCinemaList.length
        },
        resetCinema() {
            this.filterCinemaList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.searchCinemaText = ''
            this.selectCinemaCount = 0
            this.selectCinemaList = []
        },
        saveCinema() {
            // 保存为包含模式
            let cinemaName = ''
            let cinemaId = []
            this.selectCinemaList.forEach(item => {
                cinemaId.push(item.id)
            })
            if (this.selectCinemaCount === 0) {
                cinemaName = '请选择影院范围'
            } else {
                cinemaName = '已包含' + this.selectCinemaCount + '个影院'
            }
            
            this.ruleInfo.cinema_scope_type = 2 // 包含
            this.ruleInfo.cinema_scope = cinemaId
            this.ruleInfo.cinema_desc = cinemaName
            this.ruleInfo.select_cinema = this.selectCinemaList
            console.log(this.ruleInfo)
            this.selectCinema = false
        },
        
        saveCinemaExclude() {
            // 保存为排除模式
            let cinemaName = ''
            let cinemaId = []
            this.selectCinemaList.forEach(item => {
                cinemaId.push(item.id)
            })
            if (this.selectCinemaCount === 0) {
                cinemaName = '请选择影院范围'
            } else {
                cinemaName = '已排除' + this.selectCinemaCount + '个影院'
            }
            
            this.ruleInfo.cinema_scope_type = 3 // 排除
            this.ruleInfo.cinema_scope = cinemaId
            this.ruleInfo.cinema_desc = cinemaName
            this.ruleInfo.select_cinema = this.selectCinemaList
            console.log(this.ruleInfo)
            this.selectCinema = false
        },
        onCinemaClick() {
            if (this.selectCinemaList.length > 0) {
                this.showSelectCinema = true
            }
        },

        // 影厅设置
        showHallSelect() {
            this.selectHall = true;
            this.selectCount = 0;
            this.selectHallList = []
            this.filterHallList = []

            let curHallList = this.ruleInfo.hall_scope || [];
            console.log(this.defaultHallList)
            this.defaultHallList.forEach(item => {
                let checked = false
                if (curHallList != null && curHallList.indexOf(item.name) != -1) {
                    checked = true;
                    this.selectCount++;
                    this.selectHallList.push(item.name)
                }

                this.filterHallList.push({
                    label: item.name,
                    value: item.name,
                    checked: checked,
                })
            })
        },
        hallCheck(index) {
            this.filterHallList[index].checked = !this.filterHallList[index].checked;
            if (this.filterHallList[index].checked) {
                this.selectHallList.push(this.filterHallList[index].value)
                this.selectCount++
            } else {
                this.selectHallList.forEach((item, index) => {
                    if (item === this.filterHallList[index].value) {
                        this.selectHallList.splice(index, 1)
                    }
                })
                this.selectCount--
            }

        },
        resetHall() {
            this.filterHallList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.selectHallList = []
            this.selectCount = 0
        },
        searchHallClick() {

            this.filterHallList = []
            this.defaultHallList.forEach(item => {

                if (item.name.indexOf(this.searchText) != -1) {
                    let checked = false
                    this.selectHallList.forEach(item1 => {
                        if (item1.name === item.name) {
                            checked = true
                            return
                        }
                    })
                    this.filterHallList.push({
                        label: item.name,
                        value: item.name,
                        checked: checked,
                    })
                }

            })
        },
        saveHall() {
            // 保存为包含模式
            let hallName = ''
            this.selectHallList.forEach(item => {
                hallName += item + ','
            })

            if (hallName === '') {
                hallName = '请选择影厅范围'
            } else {
                hallName = '已包含' + this.selectCount + '个影厅'
            }
            
            this.ruleInfo.hall_scope_type = 2 // 包含
            this.ruleInfo.hall_scope = this.selectHallList
            this.ruleInfo.hall_desc = hallName

            this.selectHall = false
            console.log(this.ruleInfo)
        },
        
        saveHallExclude() {
            // 保存为排除模式
            let hallName = ''
            this.selectHallList.forEach(item => {
                hallName += item + ','
            })

            if (hallName === '') {
                hallName = '请选择影厅范围'
            } else {
                hallName = '已排除' + this.selectCount + '个影厅'
            }
            
            this.ruleInfo.hall_scope_type = 3 // 排除
            this.ruleInfo.hall_scope = this.selectHallList
            this.ruleInfo.hall_desc = hallName

            this.selectHall = false
            console.log(this.ruleInfo)
        },
        clearHallClick() {
            // 清除省份搜索
            this.searchText = '';
            // this.filterGplineList = this.gplineList;
            this.filterHallList = []

            this.defaultHallList.forEach(item => {
                // item.value是否在this.ruleInfo.include_province_scope中，
                let checked = false
                // 判断是否在选中省份中

                this.selectHallList.forEach(item2 => {
                    if (item2 === item.value) {
                        checked = true;
                        return
                    }
                })

                this.filterHallList.push({
                    label: item.name,
                    value: item.name,
                    checked: checked,
                })
            })
        },

        // 影片设置
        showMovieSelect() {
            this.selectMovie = true;
            this.selectCount = 0;
            this.selectMovieList = []
            this.filterMovieList = []

            let curMovieList = this.ruleInfo.movie_scope || [];
            this.movieList.forEach(item => {
                let checked = false
                if (curMovieList != null && curMovieList.indexOf(item.id) != -1) {
                    checked = true;
                    this.selectCount++;
                    this.selectMovieList.push({
                        name: item.name,
                        id: item.id
                    })
                }

                this.filterMovieList.push({
                    label: item.name,
                    value: item.id,
                    checked: checked,
                })
            })
        },
        movieCheck(index) {
            this.filterMovieList[index].checked = !this.filterMovieList[index].checked;
            if (this.filterMovieList[index].checked) {
                this.selectMovieList.push({
                    name: this.filterMovieList[index].label,
                    id: this.filterMovieList[index].value
                })
                this.selectCount++
            } else {
                this.selectMovieList.forEach((item, index1) => {
                    // console.log(item)
                    // console.log(this.filterMovieList[index])
                    if (item.id === this.filterMovieList[index].value) {
                        this.selectMovieList.splice(index1, 1)
                    }
                })
                this.selectCount--
            }
            // console.log(this.selectMovieList)

        },
        resetMovie() {
            this.filterMovieList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.selectMovieList = []
            this.selectCount = 0
        },
        searchMovieClick() {

            this.filterMovieList = []
            this.movieList.forEach(item => {

                if (item.name.indexOf(this.searchText) != -1) {
                    let checked = false
                    this.selectMovieList.forEach(item1 => {
                        if (item1.id === item.id) {
                            checked = true
                            return
                        }
                    })
                    this.filterMovieList.push({
                        label: item.name,
                        value: item.id,
                        checked: checked,
                    })
                }

            })
        },
        saveMovie() {
            // 保存为包含模式
            let name = ''
            let ids = []
            this.selectMovieList.forEach(item => {
                name += item.name + ','
                ids.push(item.id)
            })

            if (name === '') {
                name = '请选择电影范围'
            } else {
                name = '已包含' + this.selectCount + '个电影'
            }
            
            this.ruleInfo.movie_scope_type = 2 // 包含
            this.ruleInfo.movie_scope = ids
            this.ruleInfo.movie_desc = name

            this.selectMovie = false
            console.log(this.ruleInfo)
        },
        
        saveMovieExclude() {
            // 保存为排除模式
            let name = ''
            let ids = []
            this.selectMovieList.forEach(item => {
                name += item.name + ','
                ids.push(item.id)
            })

            if (name === '') {
                name = '请选择电影范围'
            } else {
                name = '已排除' + this.selectCount + '个电影'
            }
            
            this.ruleInfo.movie_scope_type = 3 // 排除
            this.ruleInfo.movie_scope = ids
            this.ruleInfo.movie_desc = name

            this.selectMovie = false
            console.log(this.ruleInfo)
        },
        clearMovieClick() {
            // 清除省份搜索
            this.searchText = '';
            // this.filterGplineList = this.gplineList;
            this.filterMovieList = []

            this.movieList.forEach(item => {
                // item.value是否在this.ruleInfo.include_province_scope中，
                let checked = false
                // 判断是否在选中省份中

                this.selectMovieList.forEach(item2 => {
                    if (item2.id === item.id) {
                        checked = true;
                        return
                    }
                })

                this.filterMovieList.push({
                    label: item.name,
                    value: item.id,
                    checked: checked,
                })
            })
        },

        // 时间
        changeTime(from) {
            console.log(from)
            this.selectTime = true;
            this.src = from;
            if (from == 1) {
                this.currentTime = this.ruleInfo.begin_time;
            } else {
                this.currentTime = this.ruleInfo.end_time;
            }
        },
        timeCheck(value) {
            console.log(value);
            if (this.src == 1) {
                this.ruleInfo.begin_time = value;
            } else {
                this.ruleInfo.end_time = value;
            }
            this.selectTime = false;
        },

        // 日期
        changeDate(from) {
            console.log(from)
            this.selectDate = true;
            this.src = from;
            var curDate = ''
            if (from == 1) {
                curDate = this.ruleInfo.begin_date;
            } else {
                curDate = this.ruleInfo.end_date;
            }
            if (curDate != '') {
                this.currentDate = new Date(curDate);
            }

            console.log(this.currentDate)
        },
        dateCheck(value) {
            var date = this.formatDate(value)
            if (this.src == 1) {
                this.ruleInfo.begin_date = date;
            } else {
                this.ruleInfo.end_date = date;
            }
            this.selectDate = false;
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}/${month}/${day}`;
        },

        // 星期设置
        showWeekSelect() {
            this.selectWeek = true;
            this.selectCount = 0;
            this.selectWeekList = []
            this.filterWeekList = []

            let curWeekList = this.ruleInfo.week_days;

            this.weekList.forEach(item => {
                let checked = false
                if (curWeekList != null) {
                    curWeekList.forEach(item1 => {
                        if (item1 === item.label) {
                            checked = true
                            return
                        }
                    })
                }

                if (checked) {
                    this.selectCount++;
                    this.selectWeekList.push({
                        name: item.label,
                        id: item.id
                    })
                }

                this.filterWeekList.push({
                    name: item.label,
                    value: item.id,
                    checked: checked,
                })
            })
            console.log(this.filterWeekList)
        },
        weekCheck(index) {
            console.log(this.filterWeekList[index])
            this.filterWeekList[index].checked = !this.filterWeekList[index].checked;
            console.log(this.filterWeekList[index])
            if (this.filterWeekList[index].checked) {
                this.selectWeekList.push({
                    name: this.filterWeekList[index].name,
                    id: this.filterWeekList[index].value
                })
                this.selectCount++
            } else {
                this.selectWeekList.forEach((item, index1) => {
                    if (item.name === this.filterWeekList[index].name) {
                        this.selectWeekList.splice(index1, 1)
                    }
                })
                this.selectCount--
            }

            console.log(this.selectWeekList)

        },
        resetWeek() {
            this.filterWeekList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.selectWeekList = []
            this.selectCount = 0
        },

        saveWeek() {

            console.log(this.selectWeekList)
            let name = ''
            let weeks = []
            this.selectWeekList.forEach(item => {
                name += item.name + '、'
                weeks.push(item.name)
            })

            if (name === '') {
                name = '设置包含星期'
            }
            this.ruleInfo['week_days'] = weeks
            this.ruleInfo.week_desc = name

            this.selectWeek = false
        },
        // 处理票数选择变化
        handleTicketCountChange(value) {
            console.log('handleTicketCountChange called, value:', value, 'inited:', this.inited, 'lastChecked:', this.lastChecked);
            if (!this.inited) {
                this.inited = true;
                return;
            }
            // 刚点了"全部"，只保留0
            if (this.lastChecked === 0) {
                if (!(value.length === 1 && value[0] === 0)) {
                    this.ruleInfo.ticket_num = [0];
                }
                return;
            }
            // 刚点了具体数字，且有0，去掉0
            if (this.lastChecked !== 0 && value.includes(0)) {
                const filtered = value.filter(v => v !== 0);
                if (filtered.length !== this.ruleInfo.ticket_num.length ||
                    filtered.some((v, i) => v !== this.ruleInfo.ticket_num[i])) {
                    this.ruleInfo.ticket_num = filtered;
                }
                return;
            }
            // 全不选，默认0
            if (value.length === 0) {
                if (!(this.ruleInfo.ticket_num.length === 1 && this.ruleInfo.ticket_num[0] === 0)) {
                    this.ruleInfo.ticket_num = [0];
                }
                return;
            }
            // 只在内容真的变化时赋值
            if (value.length !== this.ruleInfo.ticket_num.length ||
                value.some((v, i) => v !== this.ruleInfo.ticket_num[i])) {
                this.ruleInfo.ticket_num = value;
            }
        },
        
        // 添加点击事件处理，确保事件被触发
        onCheckboxClick(value) {
            console.log('onCheckboxClick called with:', value);
            console.log('点击前的 ticket_num:', this.ruleInfo.ticket_num);
            
            // 手动触发 change 事件
            this.$nextTick(() => {
                const currentValue = [...this.ruleInfo.ticket_num];
                console.log('点击后的 ticket_num:', currentValue);
                this.handleTicketCountChange(currentValue);
            });
        },
        // 保存配置
        saveConfig() {
            console.log(this.ruleInfo)
            console.log(this.configId)

            const data = {
                'name': this.ruleInfo.name,

                'hall_scope_type': 1,
                // 'hall_name': this.addConfigDialogForm.hall_name,
                'movie_scope_type': 1,
                'province_scope_type': 1,
                'city_scope_type': 1,
                'cinema_scope_type': 1,
                'gp_line_scope_type': 1,
                // 'begin_price': this.addConfigDialogForm.begin_price,
                // 'end_price': this.addConfigDialogForm.end_price,
                // 'begin_ticket': this.addConfigDialogForm.begin_ticket,
                // 'end_ticket': this.addConfigDialogForm.end_ticket,
                'date_scope': [],
                'time_scope': [],
                'week_days': this.ruleInfo.week_days,
                'bid_type': this.ruleInfo.bid_type,
                'hall_value': [],
                'status': this.ruleInfo.status,
            }
            data.time_scope.push(this.ruleInfo.begin_time)
            data.time_scope.push(this.ruleInfo.end_time)

            data.date_scope.push(this.ruleInfo.begin_date)
            data.date_scope.push(this.ruleInfo.end_date)

            if (this.ruleInfo.bid_type === 2) {
                // 影厅报价
            } else {
                data.discount = parseFloat(this.ruleInfo.discount) || 0
            }

            // 处理院线相关字段
            if (this.ruleInfo.gp_line !== 0 && this.ruleInfo.gp_line !== '') {
                data.gp_line = this.ruleInfo.gp_line
            }
            
            // 处理新版本的院线多选
            if (this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.length > 0) {
                data.gp_line_scope_type = this.ruleInfo.gp_line_scope_type
                data.gp_line_scope = JSON.stringify(this.ruleInfo.gp_line_id)
            }

            if (this.ruleInfo.begin_price !== '' && this.ruleInfo.begin_price > 0) {
                data.begin_price = this.ruleInfo.begin_price
            }

            if (this.ruleInfo.end_price !== '' && this.ruleInfo.end_price > 0) {
                data.end_price = this.ruleInfo.end_price
            }

            // 处理座位数：优先使用新版本的座位数列表
            if (this.ruleInfo.ticket_num && this.ruleInfo.ticket_num.length > 0) {
                // 按值排序，从小到大（创建新数组避免修改原数组）
                const sortedTicketNum = [...this.ruleInfo.ticket_num].sort(function (a, b) {
                    return a - b
                })
                
                // 使用新版本的座位数列表字段
                data.ticket_count_list = JSON.stringify(sortedTicketNum)
                console.log(data.ticket_count_list)
            }

            // 处理情侣座规则
            if (this.ruleInfo.seat_tag !== undefined && this.ruleInfo.seat_tag !== null) {
                data.seat_tag = this.ruleInfo.seat_tag
            }


            // 省份 - 使用统一字段
            if (this.ruleInfo.province_scope && this.ruleInfo.province_scope.length > 0) {
                data.province_scope_type = this.ruleInfo.province_scope_type
                data.province_id = this.ruleInfo.province_scope
            }

            // 城市 - 使用统一字段
            if (this.ruleInfo.city_scope && this.ruleInfo.city_scope.length > 0) {
                data.city_scope_type = this.ruleInfo.city_scope_type
                data.city_id = this.ruleInfo.city_scope
            }

            // 影院 - 使用统一字段
            if (this.ruleInfo.cinema_scope && this.ruleInfo.cinema_scope.length > 0) {
                data.cinema_scope_type = this.ruleInfo.cinema_scope_type
                data.cinema_id = this.ruleInfo.cinema_scope
            }

            // 影院分类
            if (this.ruleInfo.class_scope !== undefined && this.ruleInfo.class_scope.length > 0) {
                data.class_scope_type = this.ruleInfo.class_scope_type
                data.class_scope = this.ruleInfo.class_scope
            } else {
                data.class_scope_type = 1
                data.class_scope = []
            }

            // 影厅 - 使用统一字段
            if (this.ruleInfo.hall_scope && this.ruleInfo.hall_scope.length > 0) {
                data.hall_scope_type = this.ruleInfo.hall_scope_type
                data.hall_name = this.ruleInfo.hall_scope
            }

            // 电影 - 使用统一字段
            if (this.ruleInfo.movie_scope && this.ruleInfo.movie_scope.length > 0) {
                data.movie_scope_type = this.ruleInfo.movie_scope_type
                data.movie_id = this.ruleInfo.movie_scope
            }

            console.log(data)
            if (this.configId === undefined || this.configId === 0) {
                // 新增
                data.type = this.configType

                Api.addConfig(data).then(res => {
                    this.$notify({
                        type: 'success',
                        message: '操作成功'
                    });
                    this.goBack();
                })

            } else {
                // 更新
                data.type = this.ruleInfo.type
                data.id = this.ruleInfo.id

                Api.updateConfig(data).then(res => {
                    this.$notify({
                        type: 'success',
                        message: '操作成功'
                    });
                    this.goBack();
                })
            }
        },
        lastClick(val) {
            this.lastChecked = val;
        },
    }
}
</script>

<style lang="scss" scoped>
.home-wrap {
    height: 100%;
    background-color: #f3f3f3;

    .main-card-wrap {
        background-color: white;
        -moz-box-shadow: 2px 2px 3px #ccc;
        -webkit-box-shadow: 2px 2px 3px #ccc;
        box-shadow: 2px 2px 3px #ccc;

        .left {
            .title {
                font-size: 16px;
            }

            .btn {
                height: 34px;
                width: 120px;
                color: white;
                margin-top: 6px;
                border-radius: 4px;
                background-color: #8565bd;
            }
        }

        .right {
            margin-right: 8px
        }
    }
}

.custom-checkbox {
    cursor: pointer;
    transition: color 0.3s, background-color 0.3s, border-color 0.3s;
    padding: 2px 8px;
    /* 根据需要调整内边距 */
    border: 1px solid #dcdfe6;
    /* 边框颜色 */
    border-radius: 8px;
    /* 圆角边框 */
    display: inline-block;
    /* 使元素内联显示 */
    line-height: 1.5;
    /* 行高 */
}

/* 选中状态样式 */
.custom-checkbox.checked {
    color: #1989fa;
    /* 选中时的文字颜色 */
    background-color: #ecf5ff;
    /* 选中时的背景颜色 */
    border-color: #1989fa;
    /* 选中时的边框颜色 */
}

.bottom-row {
    position: absolute;
    bottom: 0;
    width: 100%;
}

.custom-cell {
    .van-cell__value {
        min-width: 70%;
    }
}

@media screen and (max-width: 360px) {
    .custom-cell .van-row {
        flex-direction: column !important;
    }
    .custom-cell .van-row hr {
        width: 100%;
        margin: 4px 0;
        border-left: none;
        border-right: none;
    }
}

/* 院线选择颜色样式 */
.gpline-include {
    .van-cell__value {
        color: #07c160 !important; /* 选择绿色 */
    }
}

.gpline-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

/* 省份选择颜色样式 */
.province-include {
    .van-cell__value {
        color: #07c160 !important; /* 选择绿色 */
    }
}

.province-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

/* 城市选择颜色样式 */
.city-include {
    .van-cell__value {
        color: #07c160 !important; /* 选择绿色 */
    }
}

.city-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

/* 影院选择颜色样式 */
.cinema-include {
    .van-cell__value {
        color: #07c160 !important; /* 选择绿色 */
    }
}

.cinema-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

/* 影厅选择颜色样式 */
.hall-include {
    .van-cell__value {
        color: #07c160 !important; /* 选择绿色 */
    }
}

.hall-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

/* 电影选择颜色样式 */
.movie-include {
    .van-cell__value {
        color: #07c160 !important; /* 选择绿色 */
    }
}

.movie-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

/* 影院分类 cell 颜色 */
.class-include {
    .van-cell__value {
        color: #07c160 !important;
    }
}
.class-exclude {
    .van-cell__value {
        color: #ff2c54 !important;
    }
}

/* 影院分类弹窗 */
.class-popup {
    background: #fff;
}
.class-popup-head {
    padding: 14px 16px 12px;
    border-bottom: 1px solid #ebedf0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.class-popup-title {
    font-size: 16px;
    font-weight: 600;
    color: #323233;
}
.class-popup-hint {
    font-size: 12px;
    color: #969799;
}
.class-popup-body {
    max-height: 50vh;
    min-height: 120px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.class-popup-loading {
    padding: 48px 0;
    color: #969799;
    font-size: 13px;
}
.class-popup-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border-bottom: 1px solid #f5f6f8;
    font-size: 15px;
    color: #323233;
    transition: background 0.15s;
}
.class-popup-item:active {
    background: #f7f8fa;
}
.class-popup-item.is-checked {
    background: #f0f9eb;
    color: #07c160;
}
.class-popup-item-name {
    flex: 1;
}
.class-popup-item-icon {
    font-size: 18px;
    color: #07c160;
    margin-left: 8px;
}
.class-popup-empty {
    padding: 48px 16px;
    text-align: center;
    font-size: 14px;
    color: #969799;
}
.class-popup-foot {
    display: flex;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    gap: 10px;
    border-top: 1px solid #ebedf0;
    background: #fff;
}
.class-popup-btn {
    flex: 1;
    height: 40px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: opacity 0.2s;
}
.class-popup-btn:active {
    opacity: 0.85;
}
.class-popup-btn--reset {
    background: #f2f3f5;
    color: #646566;
}
.class-popup-btn--exclude {
    background: #fff;
    color: #ee0a24;
    border: 1px solid #ee0a24;
}
.class-popup-btn--include {
    background: #07c160;
    color: #fff;
}

/* 情侣座cell样式：标题弹性宽度，避免小屏占满一行 */
.couple-seat-cell {
    ::v-deep .van-cell__title {
        min-width: 80px;
        max-width: 35%;
        flex: none !important;
    }
    
    ::v-deep .van-cell__value {
        flex: 1 !important;
    }
}

/* 票数cell样式 */
.ticket-count-cell {
    ::v-deep .van-cell__title {
        min-width: 80px;
        max-width: 35%;
        flex: none !important;
    }
    
    ::v-deep .van-cell__value {
        flex: 1 !important;
    }
}

/* 报价模式cell样式 */
.bid-mode-cell {
    ::v-deep .van-cell__title {
        min-width: 80px;
        max-width: 35%;
        flex: none !important;
    }
    
    ::v-deep .van-cell__value {
        flex: 1 !important;
    }
}
</style>

